import Image from "next/image";
import { container_classname } from "./constants";

export interface HighlightsData {
    icon: string;
    keyPoint: string;
}

const defaultHighlightsData: HighlightsData[] = [
    {
        icon: "https://assets.gallabox.com/gb-home/industry-logos/education/bot.png",
        keyPoint: "Our AI-powered system gathers data from your website to act as a knowledge base.",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/highlights/message-icon.png",
        keyPoint: "The AI chatbot you generate sits neatly on top of your WhatsApp account to respond instantly.",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/highlights/user-icon.png",
        keyPoint: "Whenever a user enters a query, the AI chatbot sends appropriate responses.",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/highlights/power-icon.png",
        keyPoint: "This goes on until the user is idle for three minutes when the chat session ends automatically.",
    },
];

interface FeatureHighlightsData {
    mainTitle?: string;
    highlightsData?: HighlightsData[];
}

const FeatureHighlights: React.FC<FeatureHighlightsData> = (props) => {
    const { mainTitle = "How does it work?", highlightsData = defaultHighlightsData } = props;
    return (
        <section className={`${container_classname} lg:py-20 py-12`}>
            <h2 className="md:text-6xl text-3xl font-semibold md:mb-12 mb-6" style={{ fontFamily: "Degular Display" }}>
                {mainTitle}
            </h2>
            <div className="w-full flex lg:flex-row flex-col lg:gap-5 gap-4">
                {highlightsData.map((highlights, index) => {
                    const { icon, keyPoint } = highlights;
                    return (
                        <div
                            key={index}
                            className="flex lg:flex-col flex-row gap-4 lg:w-1/4 w-full lg:mx-0 mx-auto lg:p-7 p-5 bg-gray-50 border border-solid border-gray-200 rounded-lg"
                        >
                            <div className="w-9 h-9 flex-shrink-0">
                                <Image width={36} height={36} src={icon} alt="icon" />
                            </div>
                            <p className="lg:text-lg text-base lg:font-medium font-normal lg:pt-6 pt-0">{keyPoint}</p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default FeatureHighlights;
